import React from 'react';
import { BrowserRouter } from 'react-router-dom'
import { Switch, Route } from 'react-router-dom';
import App from '../containers/app';
import AppHome from '../containers/app-home';
import Account from '../containers/account';
import Admin from '../containers/admin';
import Ideas from '../containers/ideas';
import IdeaDetail from '../containers/idea-detail';
import Posts from '../containers/posts';
import PostDetail from '../containers/post-detail';
import Contests from '../containers/contests';
import ContestDetail from '../containers/contest-detail';
import Cheers from '../containers/cheers';
import CheersDetail from '../containers/cheers-detail';
import Logout from './logout';
import NotFound from '../containers/not-found';

/**
 * Class to route the user to different pages
 * @class AppRouter
 */
export default class AppRouter extends React.Component {

    /**
     * Renders the AppRouter
     * @return {String} Router markup
     */
    render() {
        return (
            <BrowserRouter>
                <Switch>
                    <Route exact path="/" render={props => (<App {...this.props}/>)} />
                    <Route exact path="/home" render={props => (<AppHome {...this.props}/>)} />
                    <Route exact path="/account" render={props => (<Account {...this.props}/>)} />
                    <Route exact path="/admin" render={props => (<Admin {...this.props}/>)} />
                    <Route exact path="/ideas" render={props => (<Ideas {...this.props}/>)} />
                    <Route exact path="/ideas/:id" render={props => (<IdeaDetail {...this.props}/>)} />
                    <Route exact path="/posts" render={props => (<Posts {...this.props}/>)} />
                    <Route exact path="/posts/:id" render={props => (<PostDetail {...this.props}/>)} />
                    <Route exact path="/contests" render={props => (<Contests {...this.props}/>)} />
                    <Route exact path="/contests/:id" render={props => (<ContestDetail {...this.props}/>)} />
                    <Route exact path="/cheers" render={props => (<Cheers {...this.props}/>)} />
                    <Route exact path="/cheers/:id" render={props => (<CheersDetail {...this.props}/>)} />
                    <Route exact path="/logout" render={props => (<Logout {...this.props}/>)} />
                    <Route render={props => (<NotFound {...this.props} />)} />
                </Switch>
            </BrowserRouter>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/router.js